"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfMadValueIsValid = void 0;
const checkIfMadValueIsValid = (args) => {
    const typedArgs = args;
    let isValid = true;
    for (const sm of typedArgs) {
        if (sm.soilMoistureMAD > 100 || sm.soilMoistureMAD < 0) {
            isValid = false;
            break;
        }
    }
    return isValid;
};
exports.checkIfMadValueIsValid = checkIfMadValueIsValid;
//# sourceMappingURL=argumentValidation.js.map